<form
	[formGroup]="naturalPersonForm"
	[ngbCollapse]="!showForm"
>

	<!-- Salutation -->
	<app-form-select
		[bindLabel]="'label'"
		[bindValue]="'value'"
		[addSpaceToPrevious]="!!formConfigData?.salutation?.addSpaceToPrevious"
		[config]="formConfigData?.salutation"
		[formEntityId]="'salutation'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('salutation')"
		[itemList]="salutationList"
	></app-form-select>

	<!-- Title -->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.title?.addSpaceToPrevious"
		[config]="formConfigData?.title"
		[formEntityId]="'title'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('title')"
	></app-form-input>

	<!-- LastName -->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.lastName?.addSpaceToPrevious"
		[config]="formConfigData?.lastName"
		[formEntityId]="'lastName'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('lastName')"
	></app-form-input>

	<!-- FirstName -->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.firstName?.addSpaceToPrevious"
		[config]="formConfigData?.firstName"
		[formEntityId]="'firstName'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('firstName')"
	></app-form-input>

	<!-- NamePrefix -->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.namePrefix?.addSpaceToPrevious"
		[config]="formConfigData?.namePrefix"
		[formEntityId]="'namePrefix'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('namePrefix')"
	></app-form-input>

	<!-- NameAffix -->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.nameAffix?.addSpaceToPrevious"
		[config]="formConfigData?.nameAffix"
		[formEntityId]="'nameAffix'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('nameAffix')"
	></app-form-input>

	<!-- BirthDate -->
	<app-form-datepicker
		[addSpaceToPrevious]="!!formConfigData?.birthDate?.addSpaceToPrevious"
		[config]="formConfigData?.birthDate"
		[formEntityId]="'birthDate'"
		[formGroup]="naturalPersonForm"
		[hideErrors]="hideErrors"
		[isRequired]="hasRequiredValidator('birthDate')"
		[maxDate]="birthdayMaxDate"
		[minDate]="birthdayMinDate"
	></app-form-datepicker>
</form>
